import { render, staticRenderFns } from "./ProductDesignForm.vue?vue&type=template&id=735bf768&"
import script from "./ProductDesignForm.vue?vue&type=script&lang=js&"
export * from "./ProductDesignForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports